let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gniXe")).then(() => parcelRequire('abTGe'));